<template>
  <div class="rf-nav-wrapper navbar" v-scroll="addShadow">
    <div class="rf-logo navbar-brand">
      <div
        class="font-main is-size-3 has-text-white click navbar-item"
        @click.stop="navTo('/')"
      >
        <p>
          <span class="logo-letter upper">R</span>
          <span class="logo-letter lower">F</span>
        </p>
      </div>
      <a
        role="button"
        :class="showMenu"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="rf-menu"
        @click.stop="menu = !menu"
      >
        <span class="has-text-white" aria-hidden="true"></span>
        <span class="has-text-white" aria-hidden="true"></span>
        <span class="has-text-white" aria-hidden="true"></span>
      </a>
    </div>

    <div
      id="rf-menu"
      :class="showMenu"
      class="navbar-menu text-white font-second"
    >
      <div class="navbar-start">
        <div class="navbar-item has-text-right">
          <a class="font-ruhl rf-nav-link" @click.stop="navTo('/about')">
            About
          </a>
        </div>
        <div class="navbar-item has-text-right">
          <a class="font-ruhl rf-nav-link" @click.stop="navTo('/books')">
            Books
          </a>
        </div>
        <div class="navbar-item has-text-right">
          <a class="font-ruhl rf-nav-link" @click.stop="navTo('/instructors')">
            Instructors
          </a>
        </div>
        <div class="navbar-item has-text-right">
          <a class="font-ruhl rf-nav-link" @click.stop="navTo('/learning')">
          Winter 2026
          </a>
        </div>
        <div class="navbar-item has-text-right">
          <a class="font-ruhl rf-nav-link" @click.stop="navTo('/semesters')">
            All Semesters
          </a>
        </div>
      </div>
      <div class="navbar-end">
        <div class="navbar-item has-text-right">
          <a
            class="font-ruhl rf-nav-link"
            href="http://syllabus.russelltfuller.com/Payments.pdf"
            target="_blank"
          >
            Donate
          </a>
        </div>
        <div class="navbar-item has-text-right">
          <a class="font-ruhl rf-nav-link" @click.stop="navTo('/register')">
            Sign Up
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      headerStyle:
        'box-shadow: 0px 2px 10px rgba(0,0,0,0.5); background-color: #34324d;',
      none: 'box-shadow: none;',
      menu: false,
    }
  },
  methods: {
    addShadow(evt, el) {
      if (window.scrollY > 100) {
        el.setAttribute('style', this.headerStyle)
      } else {
        el.setAttribute('style', this.none)
      }
    },
    navTo(path) {
      this.$router.push(path).catch(e => e)
      this.menu = false
    },
  },
  computed: {
    style() {
      return (
        (this.$route.path !== '/' && {
          boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
          backgroundColor: '#34324d',
        }) ||
        {}
      )
    },
    showMenu() {
      return this.menu ? 'is-active' : ''
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_colors.scss';
.rf-nav-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  padding: 0.5em 1em;
  z-index: 100;
  background-color: transparent;
  transition: all 0.2s ease;
  .rf-logo {
    & > div > p {
      & > .logo-letter {
        display: inline-block;
        transition: all 0.2s ease-in;
      }
      & > .upper {
        transform: translateY(-3px);
      }
      & > .lower {
        transform: translateY(3px);
      }
    }
    &:hover div > p {
      & > .upper {
        transform: translateY(0px);
      }
      & > .lower {
        transform: translateY(0px);
      }
    }
  }
}
.rf-nav-link {
  /* font-family: 'Open Sans'; */
  /* font-size: 15px; */
  letter-spacing: 1.7px;
  text-transform: uppercase;
  padding: 0.25rem 0.5rem;
  /* margin-left: 2em; */
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
  color: white;
  &:hover {
    color: white;
    background-color: rgba($primary, 1);
    border: 1px solid white;
    padding: 0.25rem 1em;
  }
}
@media (max-width: 768px) {
  .rf-nav-wrapper {
    background-color: $primary;
  }
}
</style>
